import Vue from 'vue'
import moment from 'moment'

export default Vue.filter('formatHour', function (value) {
    if (value) {
        let splite = value.split(':',2);
        return  splite[0] + ':' + splite[1]

    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/libs/filter.js